import React from 'react'

import Layout from 'layouts'

import SEO from 'components/seo'
import Spacer from 'components/ui/Spacer'
import InfoSection from 'components/ui/InfoSection'
import ContactBoxesSection from './components/ContactBoxesSection'
import Footer from 'components/ui/Footer'
import VerticalScroll from 'components/layout/VerticalScroll'
import ContactButtonCTA from 'components/ui/ContactButtonCTA'

const getData = (page, type) => page?.body?.find((i) => i.type === type) || null

const ContactPage = ({ data: { prismic }, ...props }) => {
  const { page } = prismic
  const metaTitle = page?.page_meta_title
  const metaDescription = page?.page_meta_description
  const metaThumbnail = page?.page_meta_thumbnail
  const hasContacUsButton = page?.has_contact_button_cta

  return (
    <>
      <Layout lightTheme footer={<Footer />}>
        <SEO title={metaTitle} description={metaDescription} thumbnail={metaThumbnail} lightTheme />
        <VerticalScroll>
          <Spacer initial="8.6255rem" desktop="17vw" />
          <InfoSection data={getData(page, 'info_section')} />
          <Spacer initial="3.1255rem" medium="7vw" />
          <ContactBoxesSection data={getData(page, 'contact_boxes')} />
          <Spacer initial="6rem" medium="13.8vw" />
        </VerticalScroll>
      </Layout>
      {hasContacUsButton && <ContactButtonCTA />}
    </>
  )
}

export default ContactPage
